module.exports = "pegasus/assets/blocks/column-8-theme2.png";